export default __webpack_public_path__ + "static/media/KSOP_6_Degree.9b357116.png";